import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'exception/:type',
    loadChildren: () => import('./feature/exception/exception.routes').then(x => x.EXCEPTION_ROUTES),
  },
  {
    path: 'home',
    loadChildren: () => import('./feature/home/home.routes').then(x => x.HOME_ROUTES),
  },
  {
    path: 'permissions',
    loadChildren: () => import('./feature/permissions/permissions.routes').then(x => x.PERMISSIONS_ROUTES),
  },
  {
    path: 'login',
    loadChildren: () => import('./feature/login/login.routes').then(x => x.LOGIN_ROUTES),
  },
  {
    path: 'integrations/sqeptech/management',
    loadChildren: () => import('./feature/integrations/sqeptech/sqeptech.routes').then(x => x.SQEPTECH_ROUTES),
  },
  {
    path: 'integrations/cpr/management',
    loadChildren: () => import('./feature/integrations/cpr/cpr.routes').then(x => x.CPR_ROUTES),
  },
  {
    path: 'integrations/lessor/management',
    loadChildren: () => import('./feature/integrations/lessor/lessor.routes').then(x => x.LESSOR_ROUTES),
  },
  {
    path: 'integrations/visma/management',
    loadChildren: () => import('./feature/integrations/visma/visma.routes').then(x => x.VISMA_ROUTES),
  },
  {
    path: 'integrations/unit4/management',
    loadChildren: () => import('./feature/integrations/unit4/unit4.routes').then(x => x.UNIT4_ROUTES),
  },
  {
    path: 'integrations/teta/management',
    loadChildren: () => import('./feature/integrations/teta/teta.routes').then(x => x.TETA_ROUTES),
  },
  {
    path: 'integrations/promark/management',
    loadChildren: () => import('./feature/integrations/promark/promark.routes').then(x => x.PROMARK_ROUTES),
  },
  {
    path: 'integrations/tms/management',
    loadChildren: () => import('./feature/integrations/tms/tms.routes').then(x => x.TMS_ROUTES),
  },
  {
    path: 'integrations/dalcoafas/management',
    loadChildren: () => import('./feature/integrations/dalcoafas/dalcoafas.routes').then(x => x.DALCOAFAS_ROUTES),
  },
  {
    path: 'integrations/foppenafas/management',
    loadChildren: () => import('./feature/integrations/foppenafas/foppenafas.routes').then(x => x.FOPPENAFAS_ROUTES),
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
